import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import o from "../../../core/ObjectPool.js";

var l = /*#__PURE__*/function () {
  function l() {
    _classCallCheck(this, l);

    this.spans = [];
  }

  _createClass(l, [{
    key: "acquire",
    value: function acquire(o) {
      this.lodInfo = o;
    }
  }, {
    key: "release",
    value: function release() {
      this.lodInfo = null, this.spans.length = 0;
    }
  }, {
    key: "forEach",
    value: function forEach(o, _l) {
      var s = this.spans,
          t = this.lodInfo,
          e = t.level;

      if (0 !== s.length) {
        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
                r = _step$value.row,
                n = _step$value.colFrom,
                c = _step$value.colTo;

            for (var _s = n; _s <= c; _s++) {
              o.call(_l, e, r, t.normalizeCol(_s), t.getWorldForColumn(_s));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return l;
}();

l.pool = new o(l);
export { l as default };